module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-padding-b-30"
  }, [_vm._v("\n        Preview and update the discount rate on a single or multiple claims\n    ")]), _vm._v(" "), _c('book-of-business-search'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    attrs: {
      "disabled": _vm.updateDiscountRate === null
    },
    on: {
      "click": function($event) {
        return _vm.loadPreview()
      }
    }
  }, [_vm._v("\n        Preview\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.preview.data.length) ? _c('div', {
    staticStyle: {
      "margin": "20px 0 0"
    }
  }, [_vm._v("\n        Discount Rate Comparison based on " + _vm._s(_vm.preview.total) + " matching claims.\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4e03cfa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/update/PageForm.vue
// module id = 1814
// module chunks = 0